export const DEFAULT_START_PAGE = 1;
export const DEFAULT_PER_PAGE_OPTIONS = [6, 12, 18, 24];
export const INITIAL_PAGINATION_PARAM = {
    currentPage: DEFAULT_START_PAGE,
    perPageOptions: DEFAULT_PER_PAGE_OPTIONS,
    countItems: DEFAULT_PER_PAGE_OPTIONS[0],
    items: [0],
};
export var PerPageLimit;
(function (PerPageLimit) {
    PerPageLimit[PerPageLimit["DESKTOP_COMMON_DEFAULT"] = 18] = "DESKTOP_COMMON_DEFAULT";
    PerPageLimit[PerPageLimit["DESKTOP_UNITS_CLP"] = 18] = "DESKTOP_UNITS_CLP";
    PerPageLimit[PerPageLimit["DESKTOP_UNITS_PLP"] = 12] = "DESKTOP_UNITS_PLP";
    PerPageLimit[PerPageLimit["DESKTOP_PLP_ACCESSORIES"] = 24] = "DESKTOP_PLP_ACCESSORIES";
    PerPageLimit[PerPageLimit["DESKTOP_PLP_APPAREL"] = 24] = "DESKTOP_PLP_APPAREL";
    PerPageLimit[PerPageLimit["TABLET_COMMON_DEFAULT"] = 12] = "TABLET_COMMON_DEFAULT";
    PerPageLimit[PerPageLimit["MOBILE_COMMON_DEFAULT"] = 6] = "MOBILE_COMMON_DEFAULT";
})(PerPageLimit || (PerPageLimit = {}));
export var LocalizedLabels;
(function (LocalizedLabels) {
    LocalizedLabels["YES"] = "T";
    LocalizedLabels["NO"] = "F";
})(LocalizedLabels || (LocalizedLabels = {}));
export const NUMBER_FILTERS_IN_ROW = 3;
export var MeasurementUnits;
(function (MeasurementUnits) {
    MeasurementUnits["KG"] = "kg";
    MeasurementUnits["M"] = "m";
    MeasurementUnits["KW"] = "kW";
    MeasurementUnits["CC"] = "CC";
    MeasurementUnits["HP"] = "hp";
})(MeasurementUnits || (MeasurementUnits = {}));
export const RANGE_FACET_SEPARATOR = ' to ';
// Sorting types for different cases (options)
export const CLP_UNIT_SORTING = 'CLP_UNIT_SORTING';
export const PLP_UNIT_SORTING = 'PLP_UNIT_SORTING';
export const PLP_ACCESSORIES_SORTING = 'PLP_ACCESSORIES_SORTING';
export const PLP_APPAREL_SORTING = 'PLP_APPAREL_SORTING';
export const SCOOTER_ONE_HELMET_NUMBER = '1';
export const SCOOTER_TWO_HELMET_NUMBER = '2';
export const RANGE_FACET_ID = 'Range';
